import { render, staticRenderFns } from "./stamp.vue?vue&type=template&id=5254e8c6&scoped=true&"
import script from "./stamp.vue?vue&type=script&lang=js&"
export * from "./stamp.vue?vue&type=script&lang=js&"
import style0 from "./stamp.vue?vue&type=style&index=0&id=5254e8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254e8c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5254e8c6', component.options)
    } else {
      api.reload('5254e8c6', component.options)
    }
    module.hot.accept("./stamp.vue?vue&type=template&id=5254e8c6&scoped=true&", function () {
      api.rerender('5254e8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/stamp.vue"
export default component.exports